export default {
    freeWidgets: 5,

    // Сколько виджетов дарить за успешный инвайт
    inviteBonus: 2,
};